export const NAME = "search";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = (actionType: string) => `${NAME}/${actionType}`;

export const SEARCHED_TEXT_CHANGED = createActionType("SEARCHED_TEXT_CHANGED");
export const SET_SEARCH_RESULTS = createActionType("SET_SEARCH_RESULTS");
